module.exports = __webpack_public_path__ + "img/withdraw.bff6ecf8.png";